import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

export const useAddLeagueEvents = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ leagueId, eventIds }) => {
      const token = await getAccessTokenSilently();
      const apiUrl = process.env.REACT_APP_API_URL;

      const response = await axios.put(
        `${apiUrl}/api/league/${leagueId}/add-events`,
        { eventIds },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    },
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(["leagueDetails", variables.leagueId]);
      },
    },
  );
};
